import React, { useEffect, useState } from 'react';
import { animate } from 'framer-motion';

export default function AnimatedCounter({ value = 0, duration = 1.2, format = (n) => Math.round(n).toLocaleString(), className = '', prefix = '', suffix = '' }) {
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    const controls = animate(0, value, {
      duration,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(v),
    });
    return () => controls.stop();
  }, [value, duration]);

  return (
    <span className={`tabular ${className}`}>
      {prefix}{format(display)}{suffix}
    </span>
  );
}
